import { createContext, useState, useContext, ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'


type IContextOptions = {
    isPdf: boolean,
    fromDate?:string,
    toDate?:string,
    reportName?: string
    campaigns?: string[]
    publishers?: string[]
    channels?: string[]
    networks?: string[]
    countries?: string[]
    alertIds?: string[]
    includeAlerts?: boolean
    includeMonthlyPerformance?: boolean
    includeKeyMetrics?: boolean
}
type AppContextType = {
  isPdf: boolean
  fromDate?:string
  toDate?:string
  reportName?: string
  campaigns?: string[]
  publishers?: string[]
  channels?: string[]
  networks?: string[]
  countries?: string[]
  alertIds?: string[]
  includeAlerts?: boolean
  includeMonthlyPerformance?: boolean
  includeKeyMetrics?: boolean
  setPdfInfo: (opts: IContextOptions) => void
}

const defaultState: AppContextType = {
    isPdf: false,
    setPdfInfo: () => {},
}

const AppContext = createContext<AppContextType>(defaultState)

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [pdfInfo, setPdfInfo] = useState<IContextOptions>({ isPdf: false })
  
  const location = useLocation()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const pdfParam = queryParams.get('isPdf')
    const fromParam = queryParams.get('from') || undefined
    const toParam = queryParams.get('to') || undefined
    const campaignsParam = queryParams.get('campaigns') || ''
    const campaigns = campaignsParam.split(',').filter((c) => c !== '')
    const publishersParam = queryParams.get('publishers') || ''
    const publishers = publishersParam.split(',').filter((c) => c !== '')
    const channelsParam = queryParams.get('channels') || ''
    const channels = channelsParam.split(',').filter((c) => c !== '')
    const networksParam = queryParams.get('networks') || ''
    const networks = networksParam.split(',').filter((c) => c !== '')
    const countriesParam = queryParams.get('countries') || ''
    const countries = countriesParam.split(',').filter((c) => c !== '')
    const alertIdsParam = queryParams.get('alertIds') || ''
    const alertIds = alertIdsParam.split(',').filter((c) => c !== '')
    const includeAlerts = !!((queryParams.get('includeAlerts') || undefined) === 'true')
    const includeMonthlyPerformance = queryParams.get('includeMonthlyPerformance') === 'true'
    const includeKeyMetrics = queryParams.get('includeKeyMetrics') === 'true'

    const reportName = queryParams.get('reportName') || undefined

    if (pdfParam !== null) {
      setPdfInfo({isPdf: pdfParam === 'true', fromDate: fromParam, toDate: toParam, campaigns, publishers, channels, networks, countries, alertIds, reportName, includeAlerts, includeMonthlyPerformance, includeKeyMetrics })
    }
  }, [location])

  return (
    <AppContext.Provider value={{ ...pdfInfo, setPdfInfo }}>
      {children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => useContext(AppContext)
